export class DashboardViewModel {
    public BelpexLastUpdateDate: Date | string | null;
    public ElectricityLastUpdateDate: Date | string | null;
    public GasLastUpdateDate: Date | string | null;
    public OilLastUpdateDate: Date | string | null;
    public CoalLastUpdateDate: Date | string | null;
    public CotwoLastUpdateDate: Date | string | null;
    public GastwoLastUpdateDate: Date | string | null;
    public GasthreeLastUpdateDate: Date | string | null;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/dashboard-view-model.ts